import RecoverStep from "../recover_step";
import {attachContactSupportHandler, attachRowHandler, isExportToDisk, toArray} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'jobs';
const SERVER_ALIVE_BMR_JOB_TYPE = 'SERVER_ALIVE_BMR';


export default class SetJob extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const skipToNext = function () {
            const job = data.jobs[jobs_ids[0]]; // getting the one existing job
            if (!data.recovery.appliance_id) {
                //some paths allow skipping the appliance and going straight to the devices
                data.recovery.appliance_id = job.info.appliance_id;
            }
            data.recovery.job_id = job.id;
            if (job.type === SERVER_ALIVE_BMR_JOB_TYPE) {
                if ((job.drives.length === 1 && !isExportToDisk(data)) || (job.drives.length === 1 && !data.recovery.virtualization)) {
                    // use available drive, skip drive selection step
                    data.recovery.drive = job.drives[0];
                    fr.goTo('setRecoveryPoint');
                } else if (isExportToDisk(data)) {
                    // use available drive, skip drive selection step
                    data.recovery.drive = job.drives[0];

                    if (data.recovery.virtualization.production) {
                        // We deal with Production Failover VM
                        fr.goTo('setVmExportFailover');
                    } else {
                        fr.goTo('setRecoveryPoint');
                    }
                } else {
                    // multiple drives available, go to drive selection step
                    data.drives = job.drives;
                    fr.goTo('setDrive');
                }
            } else {
                // not an image job, go to recovery point selection
                fr.goTo('setRecoveryPoint');
            }
        };
        data.render = {searchComplete: false};
        //Since we have virtualization location as a possible previous step, need to test appropriately
        data.render.showOffsite = (data.restore && data.restore.type && (data.restore.type === "cloud"));

        if (data.recovery.device_id === null) {
            data.recovery.device_id = data.tmp.devices_arr[0].id;
        }
        data.jobs = data.devices[data.recovery.device_id].jobs;
        let jobs_ids = null;
        let jobs_count = 0;

        const renderJobs = function () {
            jobs_ids = Object.keys(data.jobs);
            jobs_count = jobs_ids.length;
            data.render.searchComplete = true;
            data.tmp.jobs_arr = toArray(data.jobs);
            data.offsite_entitled = (data.tmp.jobs_arr.length > 0);
            if (jobs_count === 1) {
                skipToNext();
            } else {
                fr.render("setJob");
            }
        };


        const getJobsInfo = function () {
            // get additional info
            $.ajax({
                type: "POST",
                url: "/offsite_ajax/" + (data.render.showOffsite ? "offsite_jobs" : "jobs"),
                data: JSON.stringify({deviceId: data.recovery.device_id, applianceId: data.recovery.appliance_id}),
                success: function (response) {
                    const jobs = {};
                    $.each(response.data, function (k, v) {
                        // compare jobs list, attach jobs info
                        if (data.jobs[v.appliance_assigned_id]) {
                            jobs[v.appliance_assigned_id] = data.jobs[v.appliance_assigned_id];
                            jobs[v.appliance_assigned_id].info = v;
                        }
                    });
                    data.jobs = jobs;
                    renderJobs();
                },
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json"
            }).fail(fr.defaultAJAXErrorHandler);
        };

        if (data.recovery.device_id) {
            getJobsInfo();
        } else {
            console.log('no information about this device');
            renderJobs();
        }
    }

    postRender(data, el, fr) {
        if (data.render.searchComplete) {
          const $el = $(el);
          attachRowHandler(el);
          attachContactSupportHandler(data, el, fr);
          alignHeaderOnLimitedHeightTable($el);
          $el.find('thead th:eq(1)').click();
        }
    }

    transitionNext(data, el, fr) {
        const selected_row = $(el).find('tbody tr.selected');

        if (!selected_row.length) {
            return;
        }
        data.tmp.previousStep = fr.currentStep;

        const job = data.jobs[selected_row.find('input').val()];
        data.recovery.job_id = job.id;

        if (job.type === SERVER_ALIVE_BMR_JOB_TYPE) {
            if (job.drives.length === 1) {
                data.recovery.drive = job.drives[0];
                fr.goTo('setRecoveryPoint');
            } else {
                if (typeof job.info !== 'undefined') {
                    data.tmp.last_backup = {
                        time: job.info['offsite_history_ls_end_time'],
                        str: job.info['offsite_history_ls_end_time_str']
                    };
                }
                fr.goTo('setDrive');
            }
        } else {
            fr.goTo('setRecoveryPoint');
        }
    }

    transitionBack(data, el, fr) {
        delete data.recovery.device_id;
        if (typeof data.deviceId === 'undefined') {
            fr.goTo('setDevice');
        } else {
            fr.goTo("restoreType");
        }
    }

}
